import HttpService from '../services/HttpService';
import { contains } from '../../ts-helpers/contains';
// import moment from "moment";

export const SET_LOADING = 'dispatchers_set_loading';
export const SET_HARD_LOADING = 'dispatchers_set_hard_loading';
export const UPDATE_LEGS = 'dispatchers_update_legs';
export const UPDATE_ONE_LEG = 'dispatchers_update_one_leg';
export const UPDATE_MANY_LEG = 'dispatchers_update_many_leg';
export const UNHIGHLIGHT_LEG_API_UPDATED = 'dispatchers_unhighlight_leg_api_updated';
export const UPDATE_LEGS_ONLY = 'dispatchers_update_legs_only';
export const SELECT_LEG = 'dispatchers_select_leg';
export const CHANGE_CHECKED_LEGS = 'dispatchers_change_checked_legs';
export const CHANGE_FILTER = 'dispatchers_change_filter';
export const SET_PAGE = 'dispatchers_set_page';

const getFilterSettings = (state): any => {
  const filterData = {
    ...state.DispatcherReducer.filterSettings,
    // page: state.DispatcherReducer.page || 0,
  };

  const filterCloneJson = JSON.stringify(filterData);
  const filterClone = JSON.parse(filterCloneJson);

  // filterClone.date = moment(filter.date).format("YYYY-MM-DD");
  return filterClone;
};

const filterExistingLegsOnCurrentPage = (reducer, legIdList) => {
  const existingLegs = [];
  if (reducer.filterSettings.grouped) {
    reducer.legs.forEach((trip) => {
      trip.legs.forEach((leg) => {
        if (contains(legIdList, leg.id)) {
          existingLegs.push(leg.id);
        }
      });
    });
  } else {
    reducer.legs.forEach((leg) => {
      if (contains(legIdList, leg.id)) {
        existingLegs.push(leg.id);
      }
    });
  }

  return existingLegs;
};

export const getLegs = (options = null) => {
  options = options || {};
  if (!options.hasOwnProperty('normalLoading')) {
    options.normalLoading = true;
  }
  if (!options.hasOwnProperty('hardLoading')) {
    options.hardLoading = false;
  }

  return (dispatch, getState) => {
    if (options.hardLoading) {
      dispatch({ type: SET_HARD_LOADING, payload: true });
    }
    if (options.normalLoading) {
      dispatch({ type: SET_LOADING, payload: true });
    }

    const state = getState();
    dispatch(nullifySelectedLeg());

    return fetchLegs(getFilterSettings(state)).then((data) => {
      dispatch({ type: UPDATE_LEGS, payload: data });
      if (options.hardLoading) {
        dispatch({ type: SET_HARD_LOADING, payload: false });
      }
      if (options.normalLoading) {
        dispatch({ type: SET_LOADING, payload: false });
      }
    });
  };
};

export const getLegById = (legId) => {
  return (dispatch, getState) => {
    const isLegByIdExistsInCurrentPage =
      0 != filterExistingLegsOnCurrentPage(getState().DispatcherReducer, [legId]).length;

    if (!isLegByIdExistsInCurrentPage) {
      dispatch({ type: SET_HARD_LOADING, payload: false });
      dispatch({ type: SET_LOADING, payload: false });

      return;
    }

    return fetchLegOne(legId).then((data) => {
      dispatch({ type: UPDATE_ONE_LEG, payload: data });
      dispatch({ type: SET_HARD_LOADING, payload: false });
      dispatch({ type: SET_LOADING, payload: false });
    });
  };
};

export const getLegByIdList = (legIdList, Highlight = false) => {
  return (dispatch, getState) => {
    const filteredLegIdList = filterExistingLegsOnCurrentPage(getState().DispatcherReducer, legIdList);
    if (filteredLegIdList.length == 0) {
      return;
    }

    return fetchLegMany(filteredLegIdList).then((data) => {
      dispatch({ type: UPDATE_MANY_LEG, payload: { data, Highlight } });
      dispatch({ type: SET_HARD_LOADING, payload: false });
      dispatch({ type: SET_LOADING, payload: false });
    });
  };
};

// export const changePage = (page) => {
//     return (dispatch) => {
//         dispatch({ type: SET_PAGE, payload: page });
//         dispatch(getLegs());
//     };
// };

export const enableLoading = () => {
  return (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });
  };
};

export const nullifySelectedLeg = () => {
  return (dispatch) => {
    dispatch({ type: SELECT_LEG, payload: null });
  };
};

export const updateLegsRightMenu = () => {
  return (dispatch, getState) => {
    const state = getState();
    return fetchLegs(getFilterSettings(state)).then((data) => {
      dispatch({ type: UPDATE_LEGS_ONLY, payload: data.legs });
      dispatch({ type: SET_LOADING, payload: false });
    });
  };
};

export const nullifyCheckedLegs = () => {
  return (dispatch) => {
    dispatch({ type: CHANGE_CHECKED_LEGS, payload: [] });
  };
};

export const changeFilter = (filterSettings, hardLoading = false) => {
  return (dispatch) => {
    dispatch({ type: CHANGE_FILTER, payload: filterSettings });
    dispatch({ type: SET_PAGE, payload: 0 });
    dispatch(nullifyCheckedLegs());
    dispatch(getLegs({ hardLoading }));
  };
};

export const updateLegs = () => {
  return (dispatch) => {
    dispatch(nullifyCheckedLegs());
    dispatch(getLegs());
  };
};

export const updateLegOne = (id) => {
  return (dispatch) => {
    dispatch(nullifyCheckedLegs());
    dispatch(getLegById(id));
  };
};

export const updateLegMany = (idList, Highlight = false) => {
  return (dispatch) => {
    dispatch(nullifyCheckedLegs());
    dispatch(getLegByIdList(idList, Highlight));
  };
};

export const unhighlightApiUpdatedLegs = () => {
  return (dispatch) => {
    dispatch(nullifyCheckedLegs());
    dispatch({ type: UNHIGHLIGHT_LEG_API_UPDATED });
  };
};

export const toggleCheckLeg = (legId) => {
  return (dispatch, getState) => {
    const state = getState();
    const checkedLegs = state.DispatcherReducer.checkedLegs;
    if (checkedLegs.indexOf(legId) > -1) {
      checkedLegs.splice(checkedLegs.indexOf(legId), 1);
    } else {
      checkedLegs.push(legId);
    }

    dispatch({ type: CHANGE_CHECKED_LEGS, payload: [...checkedLegs] });
  };
};

export const toggleSelectLeg = (leg) => {
  return (dispatch, getState) => {
    const state = getState();
    const selectedLeg = state.DispatcherReducer.selectedLeg;
    if (selectedLeg === leg) {
      dispatch({ type: SELECT_LEG, payload: null });
    } else {
      dispatch({ type: SELECT_LEG, payload: leg });
    }
  };
};

export const fetchLegs = (filterSettings) => {
  return HttpService.post(`/admin/dispatchers/get`, filterSettings)
    .then((response) => response.json())
    .then((data) => data);
};

export const fetchLegOne = (legId) => {
  return HttpService.get(`/admin/dispatchers/get-one-leg/${legId}`)
    .then((response) => response.json())
    .then((data) => data);
};

export const fetchLegMany = (legIdList) => {
  return HttpService.post(`/admin/dispatchers/get-many-legs`, { ids: legIdList })
    .then((response) => response.json())
    .then((data) => data);
};
